module.exports = __webpack_public_path__ + "img/secondService.535b5983.svg";